<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="#FFF7F2"
    />
    <g clip-path="url(#clip0_3657_1415)">
      <path
        d="M12.8581 24.988L10.8089 15.2856C10.7485 14.9999 10.4679 14.817 10.1823 14.8775C9.89647 14.9378 9.71384 15.2185 9.77415 15.5042L11.8233 25.2066C11.8759 25.4556 12.0955 25.6263 12.3402 25.6263C12.3764 25.6263 12.4132 25.6225 12.45 25.6147C12.7358 25.5543 12.9185 25.2738 12.8581 24.988Z"
        fill="#040325"
      />
      <path
        d="M11.0954 24.9881L9.04623 15.2856C8.98598 14.9998 8.7051 14.8171 8.41964 14.8775C8.13385 14.9378 7.95116 15.2184 8.01153 15.5042L10.0606 25.2066C10.1132 25.4555 10.3328 25.6263 10.5775 25.6263C10.6137 25.6263 10.6505 25.6225 10.6873 25.6147C10.9731 25.5543 11.1557 25.2738 11.0954 24.9881Z"
        fill="#040325"
      />
      <path
        d="M30.9424 14.9194H28.8386H27.6205C27.3144 14.9194 27.0387 15.0495 26.8455 15.2574C26.6525 15.0495 26.3767 14.9194 26.0705 14.9194H25.443C25.4374 14.9194 25.4318 14.9201 25.4261 14.9202C25.4268 14.9202 25.4275 14.9201 25.4282 14.9201C25.4239 14.9201 25.4198 14.9194 25.4155 14.9194H23.0532H22.4626C22.1499 14.9194 21.8654 15.056 21.6705 15.2763C21.5784 15.1819 21.4692 15.1049 21.3481 15.0501C21.1964 14.9666 21.0224 14.9194 20.8387 14.9194H17.4062C17.1202 14.9194 16.8575 15.0338 16.6655 15.2222C16.4735 15.0338 16.2109 14.9194 15.9248 14.9194H15.8194H12.8299C12.511 14.9194 12.2092 15.0633 12.0083 15.311C11.8075 15.5587 11.7292 15.8837 11.7951 16.1956L13.6035 24.7583C13.7068 25.2475 14.1384 25.5975 14.6383 25.5975H18.1076H18.4029C18.6972 25.5975 18.9662 25.4765 19.1595 25.2788C19.3527 25.4765 19.622 25.5975 19.9161 25.5975H19.953H23.6069H23.6438C23.8809 25.5975 24.1022 25.5179 24.281 25.3828C24.3799 25.4188 24.4801 25.4518 24.5824 25.4789C25.1846 25.6855 25.9175 25.7819 26.8824 25.7819H27.0302C27.0592 25.7819 27.0879 25.7808 27.1164 25.7784C28.6161 25.7439 29.7956 25.3773 30.6228 24.688C30.6315 24.6808 30.6401 24.6734 30.6485 24.6658C31.5453 23.8685 32 22.696 32 21.1809V15.977C32 15.393 31.5264 14.9194 30.9424 14.9194ZM23.1681 24.2312C23.1681 24.2313 23.1681 24.2313 23.1681 24.2313C23.1224 24.4484 22.996 24.5195 22.892 24.5399H19.9529H19.916L19.1595 19.1357L18.4028 24.5399H18.1075H14.6382L12.8299 15.9773H15.8194L15.9248 15.9772L16.6483 20.9052L17.4062 15.9772H20.8387L20.8443 16.0142H20.9126L21.6696 21.2767L22.4625 15.9772H23.0532H23.4615H24.3621H24.9024L23.1681 24.2312ZM30.9423 21.1811C30.9423 22.3991 30.61 23.2849 29.9457 23.8756C29.3059 24.4087 28.3224 24.7015 27.0305 24.7224L27.03 24.7243H26.8822C26.0703 24.7243 25.4061 24.6504 24.8892 24.4659C24.6566 24.4079 24.445 24.3187 24.2532 24.2101L25.9604 16.0859C25.9681 16.0494 25.9717 16.0131 25.9717 15.9772H26.0704V21.292C26.0704 21.6609 26.1074 21.9563 26.2549 22.1408C26.4026 22.3253 26.5872 22.4361 26.8453 22.4361C27.0669 22.4361 27.2515 22.3253 27.399 22.1408C27.5466 21.9563 27.6205 21.6609 27.6205 21.329V15.9772H28.8385H30.9423V21.1811Z"
        fill="#040325"
      />
    </g>
    <defs>
      <clipPath id="clip0_3657_1415">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(8 8)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
